var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMnemonic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Out_line",
    "data-name": "Out line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m493.65723 114.34326-96-96a8.00076 8.00076 0 0 0 -5.65723-2.34326h-192a8.00008 8.00008 0 0 0 -8 8v48h16v-40h176v88a8.00008 8.00008 0 0 0 8 8h88v296h-240v16h248a8.00008 8.00008 0 0 0 8-8v-312a8.00035 8.00035 0 0 0 -2.34277-5.65674zm-93.65723-71.02978 68.68652 68.68652h-68.68652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 104h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 168h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 168h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432 168h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 200h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 200h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352 232h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 232h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384 264h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 320h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 352h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 424h-8v-19.217a160.48271 160.48271 0 0 0 124.7832-124.783h35.2168v-16h-32.79785q.78808-7.8955.79785-16c0-88.22412-71.77539-160-160-160s-160 71.77588-160 160c0 77.26831 55.05664 141.91748 128 156.783v19.217h-8a8.00008 8.00008 0 0 0 -8 8v64h16v-56h64v56h16v-64a8.00008 8.00008 0 0 0 -8-8zm-184-176c0-79.40186 64.59766-144 144-144s144 64.59814 144 144-64.59766 144-144 144-144-64.59814-144-144zm128 159.20227q7.8955.78753 16 .79773 8.09911 0 16-.79773v16.79773h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 248a128 128 0 1 0 -128 128 128.14509 128.14509 0 0 0 128-128zm-240 0a112 112 0 1 1 112 112 112.12706 112.12706 0 0 1 -112-112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 176h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 176h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 176h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 208h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 208h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 208h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 240h80v16h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 240h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 240h32v16h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 272h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 272h64v16h-64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 272h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 304h48v16h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 304h64v16h-64z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnemonic);
export default __webpack_public_path__ + "static/media/mnemonic.ebf3ac8e.svg";
export { ForwardRef as ReactComponent };